/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import dayjs from '@/lib/dayjs';
import type { YextHolidayHour } from '../interface/yext-types';
import type { LocationsDay } from '../interface/types';

const DAY_INDEX_TO_NAME: LocationsDay[] = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export function getHolidayHoursForWeek(
  holidayHours: YextHolidayHour[] | undefined,
  storeTimezone?: string,
): Partial<Record<LocationsDay, YextHolidayHour>> {
  const result: Partial<Record<LocationsDay, YextHolidayHour>> = {};

  if (!holidayHours || holidayHours.length === 0) {
    return result;
  }

  const now = storeTimezone ? dayjs().tz(storeTimezone) : dayjs();
  const currentDayOfWeek = now.day(); // 0 = Sunday

  const mondayOffset = currentDayOfWeek === 0 ? -6 : 1 - currentDayOfWeek;
  const monday = now.add(mondayOffset, 'day').startOf('day');
  const sunday = monday.add(6, 'day').endOf('day');

  for (const holiday of holidayHours) {
    const holidayDate = dayjs(holiday.date);

    if (
      (holidayDate.isAfter(monday) || holidayDate.isSame(monday, 'day')) &&
      (holidayDate.isBefore(sunday) || holidayDate.isSame(sunday, 'day'))
    ) {
      const dayName = DAY_INDEX_TO_NAME[holidayDate.day()];
      result[dayName] = holiday;
    }
  }

  return result;
}
